import { createApp, h } from "vue";
import ChartApp from "./components/ChartApp.vue";

const charts = document.querySelectorAll(".js-chart-app");
Array.prototype.forEach.call(charts, (el) => {
  //gather props from data-attributes
  const loadingSlot = el.querySelector("[data-vue-slot='loading']");
  const permalink = JSON.parse(el.dataset.permalink);
  const title = JSON.parse(el.dataset.title);
  const subtitle = JSON.parse(el.dataset.subtitle);
  const slug = JSON.parse(el.dataset.slug);
  const jsonUrl = JSON.parse(el.dataset.jsonUrl);
  const data = JSON.parse(el.dataset.data);
  const buttonTitles = JSON.parse(el.dataset.buttonTitles);
  const chartMargin = JSON.parse(el.dataset.chartMargin);
  const showLegend = JSON.parse(el.dataset.showLegend);
  const legendId = JSON.parse(el.dataset.legendId);
  const downloads = JSON.parse(el.dataset.downloads);
  const app = createApp({
    components: {
      ChartApp,
    },
    render: function () {
      return h("article", { class: el.classList.value, ref: "chartApp" }, [
        h(
          ChartApp,
          {
            permalink: permalink,
            title: title,
            subtitle: subtitle,
            slug: slug,
            jsonUrl: jsonUrl,
            data: data,
            buttonTitles: buttonTitles,
            chartMargin: chartMargin,
            showLegend: showLegend,
            legendId: legendId,
            downloads: downloads,
          },
          {
            loading: () =>
              h(loadingSlot.tagName, {
                class: Array.from(loadingSlot.classList),
                innerHTML: loadingSlot.innerHTML,
              }),
          }
        ),
      ]);
    },
  });
  app.mount(el);
});
